<template>
  <div class="data-panel ux-experience-panel">
    <ue :pd="ues.pd" :content="ues.content" v-if="$service.PROJ_CODE==='l28' || $service.PROJ_CODE==='demo'"></ue>
    <div class="data-panel-header">
      <!-- <h2>{{title}}</h2> -->
      <div class="extra">
        <template v-if="!isSimple">
          <label class="ux-filter-title">玩法</label>
          <a-radio-group v-model="filterMode" style="margin-right: 4px;" button-style="solid">
            <a-radio-button v-for="pm in options.modes" :key="pm.value" :value="pm.id">{{pm.label}}</a-radio-button>
          </a-radio-group>          
        </template>
        <label :style="{marginLeft: '14px'}" class="ux-filter-title">日期</label>
        <a-radio-group v-model="filterDate" style="margin-right: 4px;" button-style="solid">
          <a-radio-button v-for="pdate in options.dates" :key="pdate.value" :value="pdate.id">{{pdate.label}}</a-radio-button>
        </a-radio-group>        
        <a-range-picker :value="range_value" @change="changeFilterDate" :disabled-date="disabledRangeDate" :allowClear="false"  v-if="$service.PROJ_CODE!='l28'"/>
        <RangePicker :value="range_value" :defaultValue="range_value" @change="changeFilterDate"  v-else style="width:300px; display: inline-block;"/>
        
        
        <!-- <label class="ux-filter-title" :style="{marginLeft: '20px'}">平台</label>
        <a-radio-group v-model="selectedPlatform" button-style="solid">
          <a-radio-button value="all">全部</a-radio-button>
          <a-radio-button value="iOS">iOS</a-radio-button>
          <a-radio-button value="Android">Android</a-radio-button>
        </a-radio-group> -->
        <!-- <a-radio-group v-model="display" style="margin:0 0 0 16px;">
          <a-radio-button value="chart">{{ $t('common.chart') }}</a-radio-button>
          <a-radio-button value="table">{{ $t('common.table') }}</a-radio-button>
        </a-radio-group> -->
      </div>
    </div>
    <div :style="{paddingTop: '12px'}">
      <a-button v-if="selectedDate" type="dashed" :disabled="!selectedDate" @click="selectedDate=undefined"><a-icon type="left" />返回</a-button>
      <span class="v-notice" v-else>注：可点击数据标记查看该日期评分分布</span>
    </div>
    <div class="data-panel-content ux-experience-panel-content">
      <UxChart :data="chartData" :remarkMap="remarkMap" @handleEditRemark="handleEditRemark" :selectedDate="selectedDate" @changeSelectedDate="changeSelectedDate" 
        :selectedMode="selectedMode" :isSimple="isSimple" />
      <!-- <data-table :fields="dataColumns" :datas="userTestList" ref="user-test-table" class="fixed-datatable" :class="{hidepanel:display!=='table'}" /> -->
      <!-- <div class="table-operator" v-if="display === 'table'">
        <UxUpload v-if="canEdit" @refresh="getExperienceOverview" />
        <a-button @click="exportToExcel('user-test-table', `${exportFileName}.xlsx`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
        <a-button @click="copy('user-test-table')" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
      </div> -->
      <UxTestTable :loading="loading" :style="{paddingTop: '14px'}" :class="{hidepanel:display!=='table'}" :data="chartData" ref="user-test-table" @updateItem="updateUserTestList" :canEdit="canEdit" 
        :selectedDate="selectedDate" :selectedPlatform="selectedPlatform" :remarkMap="remarkMap" @handleEditRemark="handleEditRemark" @changeSelectedDate="changeSelectedDate" :selectedMode="selectedMode"
        :modeOptions="options.modes" :isSimple="isSimple" :selectedCategoryType="selectedCategoryType" />
    </div>
    <a-modal :title="`编辑 ${formatTime(modal.curVer)}`" :width="640" :visible="modal.visible" :maskClosable="false" @cancel="handleCancelEditRemark" @ok="handleConfirmEditRemark" >
      <a-form :form="form" ref="form" :selfUpdate="true" :label-col="{span: 3}" :wrapper-col="{span: 20}" >
        <a-form-item :label="isSimple ? '备注' : 'Android'">
          <a-textarea :placeholder="`请输入${isSimple ? '' : 'Android'}版本总结`" v-decorator="['android_content']" :autosize="{ minRows: 4, maxRows: 6 }"/>
        </a-form-item>
        <a-form-item v-if="!isSimple" label="iOS">
          <a-textarea placeholder="请输入iOS版本总结" v-decorator="['ios_content']" :autosize="{ minRows: 4, maxRows: 6 }"/>
        </a-form-item>
        <a-form-item v-if="!isSimple" label="手柄版">
          <a-textarea placeholder="请输入手柄版（XGP）版本总结" v-decorator="['xgp_content']" :autosize="{ minRows: 4, maxRows: 6 }"/>
        </a-form-item>
        <a-form-item v-if="!isSimple" label="其他">
          <a-textarea placeholder="请输入其他备注" v-decorator="['extra_content']" :autosize="{ minRows: 1, maxRows: 3 }"/>
        </a-form-item>
      </a-form>
    </a-modal>    
  </div>
</template>

<script>
import moment from "moment"
import DataTable from '@/components/common/datatable.vue'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js';
import UxTestTable from './uxExperience/ux-test-table.vue';
import UxChart from './uxExperience/ux-chart.vue';
import UxUpload from './uxExperience/ux-upload.vue';
import _ from 'lodash';
import RangePicker from "@/components/common/search/range_picker.vue";
import ue from './uxExperience/ue.vue'
import { MODE_ID_MAP, CATEGORY_TYPE_MAP } from '@/constants/fixed';

export default {
  name: 'uxExperiencePanel',
  mixins: [datatableMixin],
  components: {
    DataTable,
    UxTestTable,
    UxChart,
    UxUpload,
    RangePicker,
    ue
  },
  props: {
    api: {
      type: String,
    },
    title: {
      type: String,
      default: 'UX体验管理'
    }
  },
  data() {
    return {
      ues: {
        pd: [{name: '张皓宇', email: 'zhanghaoyu07@corp.netease.com'}],
        content: [{name: '张皓宇', email: 'zhanghaoyu07@corp.netease.com'}]
      },
      display: 'table',
      loading: false,
      userTestList: [],
      remarkList: [],
      exportFileName: `${this.$service.PROJ_CODE}-${this.title}-${moment().format('YYYY-MM-DD')}`,
      selectedPlatform: 'all',
      selectedDate: undefined,
      form: this.$form.createForm(this, {name: 'version-remark'}),
      modal: {
        curVer: '',
        visible: false,
      },
      filterDate: `${moment().subtract(3, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`,
      filterMode: -1,
      options: {
        dates: [
          { id: `${moment().subtract(7, 'days').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近7天' },
          { id: `${moment().subtract(1, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近一个月' },
          { id: `${moment().subtract(3, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近三个月' },
        ],
        modes: [
          { id: MODE_ID_MAP.ALL, label: '整体' },
          { id: MODE_ID_MAP.TOUR, label: '巡回赛' },          
          { id: MODE_ID_MAP.SOLO, label: 'SOLO' },
          { id: MODE_ID_MAP.SMASH, label: 'SMASH' },
          // { id: MODE_ID_MAP.TROIS, label: '3v3v3' },
          { id: MODE_ID_MAP.BUDDY_CUP, label: '锦标赛' },
        ]
      },
      // FIXME: 还有新游戏，调整为模板配置
      isSimple: this.$service.PROJ_CODE === "l22"
    }
  },
  computed: {
    filterUserTestList() {
      const [start_date, end_date] = this.filterDate.split('|');
      return this.userTestList.filter(ue => {
        const f_platform = this.selectedPlatform === 'all' ? true : ue.platform === this.selectedPlatform;
        const tmp_cur_date = moment(ue.review_time).format('YYYY-MM-DD');
        const f_daterange = moment(tmp_cur_date).isBetween(start_date, end_date, undefined, '[]');
        let f_mode = true;
        if (this.filterMode === MODE_ID_MAP.TROIS) {
          f_mode = ue.type === CATEGORY_TYPE_MAP.TROIS;
        } else if (this.filterMode === MODE_ID_MAP.BUDDY_CUP) {
          f_mode = ue.type === CATEGORY_TYPE_MAP.BUDDY_CUP;
        } else if (this.filterMode === MODE_ID_MAP.ALL) {
          f_mode = _.isNil(ue.type) || ue.type === CATEGORY_TYPE_MAP.BASE;
        } else {
          f_mode = (_.isNil(ue.type) || ue.type === CATEGORY_TYPE_MAP.BASE) && _.isNumber(ue.mode_rate?.[this.filterMode]);
        }
        return f_platform && f_daterange && f_mode;
      });
    },
    chartData() {
      const avgRateMap = {};
      this.filterUserTestList.forEach(ue => {
        const tmpRate = [MODE_ID_MAP.ALL, MODE_ID_MAP.TROIS, MODE_ID_MAP.BUDDY_CUP].includes(this.filterMode) ? ue.rate : ue.mode_rate[this.filterMode];
        const curRate = _.isNumber(tmpRate) ? tmpRate : 0;
        const curPlatform = ue.platform === 'iOS' ? 'iOS' : ue.platform === '手柄版（XGP）' ? '手柄版（XGP）' : 'Android'; // 其他平台
        if (!avgRateMap[ue.review_time]) {
          avgRateMap[ue.review_time] = {
            total: {
              rate: curRate,
              count: 1
            },
            iOS: {
              rate: 0,
              count: 0,
            },
            Android: {
              rate: 0,
              count: 0,
            },
            "手柄版（XGP）": {
              rate: 0,
              count: 0,
            }
          }
          avgRateMap[ue.review_time][curPlatform].rate = curRate;
          avgRateMap[ue.review_time][curPlatform].count = 1;
        } else {
          avgRateMap[ue.review_time].total.rate = avgRateMap[ue.review_time].total.rate + curRate;
          avgRateMap[ue.review_time].total.count += 1;
          avgRateMap[ue.review_time][curPlatform].rate = avgRateMap[ue.review_time][curPlatform].rate + curRate;
          avgRateMap[ue.review_time][curPlatform].count += 1;
        }
      });
      return (_.sortBy(this.filterUserTestList, ['review_time'])).map(v => {
        const curPlatform = v.platform === 'iOS' ? 'iOS' : v.platform === '手柄版（XGP）' ? '手柄版（XGP）' : 'Android';
        return {
          ...v,
          review_id: v.review_id.toString(),
          avg_rate: _.round(avgRateMap[v.review_time].total.rate / avgRateMap[v.review_time].total.count, 1),
          platform_rate: _.round(avgRateMap[v.review_time][curPlatform].rate / avgRateMap[v.review_time][curPlatform].count, 1),
          avg_rate_map: avgRateMap[v.review_time],
          rate: [MODE_ID_MAP.ALL, MODE_ID_MAP.TROIS, MODE_ID_MAP.BUDDY_CUP].includes(this.filterMode) ? v.rate : v.mode_rate[this.filterMode]
        }
      });
    },
    canEdit() {
      return this.$store.state.user.staff;
    },
    filterRemarkList() {
      return this.remarkList.filter(r => {
        if (this.filterMode === MODE_ID_MAP.TROIS) {
          return r.type === CATEGORY_TYPE_MAP.TROIS;
        } else if (this.filterMode === MODE_ID_MAP.BUDDY_CUP) {
          return r.type === CATEGORY_TYPE_MAP.BUDDY_CUP;
        } else {
          return _.isNil(r.type) || r.type === CATEGORY_TYPE_MAP.BASE;
        }
      });
    },
    remarkMap() {
      const rMap = {};
      this.filterRemarkList.forEach(vr => {
        rMap[vr.review_time] = vr;
      });
      return rMap;
    },
    range_value() {
      const [start_dt, end_dt] = this.filterDate.split('|');
      return [moment(start_dt), moment(end_dt)]
    },
    selectedMode() {
      return this.options.modes.find(m => m.id === this.filterMode);
    },
    selectedCategoryType() {
      const { id } = this.selectedMode;
      if (id === MODE_ID_MAP.TROIS) {
        return CATEGORY_TYPE_MAP.TROIS;
      } else if (id === MODE_ID_MAP.BUDDY_CUP) {
        return CATEGORY_TYPE_MAP.BUDDY_CUP;
      } else {
        return CATEGORY_TYPE_MAP.BASE;
      }
    }
  },
  watch: {
  },
  mounted() {
    this.getExperienceOverview();
  },
  methods: {
    formatTime(t) {
      return moment(t).format('YYYY-MM-DD')
    },
    getExperienceOverview() {
      this.loading = true;
      this.$service.query_fixed_module(this.api).then(res => {
        this.loading = false;
        if (res.data) {
          this.userTestList = res.data.list || [];
          this.remarkList = res.data.remark || [];
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    updateUserTestList(type, data) {
      switch(type) {
        case 'delete':
          this.userTestList = this.userTestList.filter(ue => ue.review_id.toString() !== data.review_id && ue.type === data.type)
          break;
        case 'update':
          this.userTestList = this.userTestList.map(ue => (
            ue.review_id.toString() === data.review_id && ue.type === data.type ? {
              ...ue,
              ...data
            } : ue
          ))
          break;
        default:
          break;
      }
    },
    updateRemark(data) {
      const existIdx = this.remarkList.findIndex(vr => vr.review_time === data.review_time && vr.type === data.type);
      if (existIdx === -1) {
        this.remarkList.push(data);
      } else {
        this.remarkList.splice(existIdx, 1, data);
      }
    },
    changeSelectedDate(val) {
      this.selectedDate = val;
    },
    handleEditRemark(v) {
      this.modal.visible = true;
      this.modal.curVer = v.label;

      this.$nextTick(function() {
        this.form.setFieldsValue({
          android_content: this.remarkMap[v.label]?.android_content || undefined,
          ios_content: this.remarkMap[v.label]?.ios_content || undefined,
          xgp_content: this.remarkMap[v.label]?.xgp_content || undefined,
          extra_content: this.remarkMap[v.label]?.extra_content || undefined,
        })
      });
    },
    handleCancelEditRemark() {
      this.modal.visible = false;
      this.form.resetFields();
    },
    handleConfirmEditRemark() {
      this.form.validateFields().then(async () => {
        const formVals = this.form.getFieldsValue();
        const params = {
          review_time: this.modal.curVer,
          android_content: formVals.android_content,
          ios_content: formVals.ios_content,
          xgp_content: formVals.xgp_content,
          extra_content: formVals.extra_content,
          type: this.selectedCategoryType
        };

        this.$service.addData(`${this.$service.api.project.query_fixed_module}experience_overview_remark/`, params).then((d) => {
          this.$message.success(`编辑 ${this.formatTime(this.modal.curVer)} 成功`);
          this.modal.visible = false;
          this.form.resetFields();

          this.updateRemark(params);
        }).catch(err => {
          this.$message.error(`编辑 ${this.formatTime(this.modal.curVer)} 失败`);
        });    
      })
    },
    changeFilterDate(value) {
      const [start_date, end_date] = value;
      this.filterDate = `${start_date.format('YYYY-MM-DD')}|${end_date.format('YYYY-MM-DD')}`;
    },
    disabledRangeDate(current) {
      return current && current > moment().endOf('day');
    }
  }
}
</script>

<style lang="less">
.ux-experience-panel {
  padding-bottom: 20px;
  &.data-panel {
    margin-top: 0;
  }
  .v-notice {
    color: #B7B7B7;
    padding-left: 4px;
  }
  .table-operator {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 8px 0 16px;
  }
  .g2-tooltip {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 3px;
    color: rgb(87, 87, 87);
    font-size: 12px;
    line-height: 20px;
    padding: 10px 10px 6px 10px;
    z-index: 99;
  }
  .g2-tooltip-title {
    font-weight: bold;
    font-size: 14px;
  }
  .g2-tooltip-summary {
    border-bottom: 2px solid #8B7E74;
    font-weight: bold;
  }
  .g2-tooltip-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .multi-wrap {
    display: flex;
    justify-content: space-between;
  }
  .g2-tooltip-value {
    margin-left: 12px;
    // display: inline;
    float: right;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    max-width: 160px;
    overflow: hidden;
    // white-space: nowrap;
    text-overflow: ellipsis;
  }
  .ux-filter-title {
    margin-right: 12px;
    font-weight: bold;
  }
}

.ux-exp-tabs {
  padding-top: 20px;
  &.ant-tabs-card {
    .ant-tabs-content {
      margin-top: -16px;
      // .ant-tabs-tabpane {
      //   background: #fff;
      // }
    }
    .ant-tabs-bar {
      border-color: #fff;
      .ant-tabs-tab {
        border-color: transparent;
        background: transparent;
        font-size: 16px;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
      }
    }
  }
}
</style>